module.exports = __webpack_public_path__ + "img/79_46.560f42d2.png";